import LogicaAPI from "./logicaapi";

class PaymentInstruments extends LogicaAPI {
  async getPaymentInstruments(args) {
    let params;
    if (args.type) {
      params = {
        status_scope: "activated",
        payment_method_id: parseInt(args.type, 10),
      };
    } else {
      params = {
        status_scope: "activated",
      };
    }
    if (args.scope) {
      params.status_scope = args.scope;
    }
    const res = this.get("/api/v1/users/payment_instruments", { params });
    return res;
  }

  async paymentInstrument(id) {
    return this.get(`/api/v1/users/payment_instruments/${id}`);
  }

  async paymentInstrumentsCreateCreditCard(args) {
    const params = {
      payment_method_id: args.payment_method_id,
      token: args.token,
      token_key: args.token_key,
      success_url: decodeURIComponent(args.success_url),
      cancel_url: decodeURIComponent(args.cancel_url),
      error_url: decodeURIComponent(args.error_url),
      options: {
        tds_info_token: args.tds_info_token,
        tds_info_token_key: args.tds_info_token_key,
      },
    };
    return this.post("/api/v1/users/payment_instruments/create", {
      body: params,
    });
  }

  async paymentInstrumentsCreateOther(
    payment_method_id,
    replace_flag,
    success_url,
    cancel_url,
    error_url
  ) {
    const params = {
      payment_method_id: payment_method_id,
      replace_flag: replace_flag,
      success_url: decodeURIComponent(success_url),
      cancel_url: decodeURIComponent(cancel_url),
      error_url: decodeURIComponent(error_url),
    };

    return this.post("/api/v1/users/payment_instruments/create", {
      body: params,
    });
  }

  async paymentInstrumentsActivate(args) {
    const id = args.payment_instrument_id;
    const params = {
      payment_instrument_id: id,
    };
    // エンドポイントが違うので注意
    return this.post(`/api/v1/sbps/payment_instruments/${id}/activate`, {
      body: params,
    });
  }

  async paymentInstrumentsDeactivate(args) {
    const id = args.payment_instrument_id;
    return this.post(`/api/v1/users/payment_instruments/${id}/deactivate`,{});
  }

  async paymentInstrumentsSetDefault(args) {
    const id = args.payment_instrument_id;
    const params = {
      payment_instrument_id: id,
      default_flag: true,
    };
    return this.post(`/api/v1/users/payment_instruments/${id}/edit`, {
      body: params,
    });
  }
}
export default PaymentInstruments;
